module.exports = __webpack_public_path__ + "static/media/page6small.03a26624.png";